import React from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { useRequest } from 'hooks';

import { Form, Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

const Copy = () => {
	// Cache current webinar's id
	const { id } = useParams();

	// Use router's history
	const history = useHistory();

	// Store request
	const [[progress], request] = useRequest('put', `webinars/${id}`);

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = async event => {
		event.preventDefault();

		// Try to update webinar's data
		const [success, error] = await request(null, {
			related: 'copy'
		});

		// Redirect on success
		if (success) return history.push(`/webinars/${success.id}`);

		// TODO: Think of a better way of handling errors
		if (error) return console.log(error);
	};

	return (
		<Form
			onSubmit={onSubmit}
			className="mt-4 p-4 flex flex-col gap-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			<Title
				title="Izveidot kopiju"
				className="text-xl"
			/>

			<div className="text-neutral-800 dark:text-white transition-colors">
				Tiks izveidota kopija dotajam vebināram. Vebinārs tiks piesaistīts esošajam mācību kursam un modulim, taču izveidotais vebinārs nebūs redzams studentiem!
			</div>

			<div className="flex justify-end">
				<Button
					submit
					icon="content_copy"
					value="Izveidot kopiju"
					theme="warning"
					progress={progress}
				/>
			</div>
		</Form>
	);
};

export default Copy;
